import { useTranslation } from 'react-i18next';

import { UserRoleEnum } from '~enums';
import useAuthorize from '~hooks/useAuthorize';
import PageLayout from '~layouts/page/pageLayout';

import UsersOverviewContainer from '../containers/usersOverviewContainer';

const UsersPage = () => {
	const { t } = useTranslation('entities');
	const { authorize } = useAuthorize();
	const isSuperAdmin = authorize([UserRoleEnum.SuperAdmin]);

	return (
		<PageLayout
			pageTitle={t('user.labels.plural')}
			headerInfo={{
				title: t('user.labels.plural'),
			}}
		>
			<UsersOverviewContainer
				showOrganisationFilter={isSuperAdmin}
				showOrganisationColumn={isSuperAdmin}
				showSuperAdminRole={isSuperAdmin}
			/>
		</PageLayout>
	);
};

export default UsersPage;
